import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Spin,
  Switch,
  Typography,
} from "antd";
import React, { useEffect, useState } from "react";
import moment from "moment";

import ManagementPageContainer from "../../components/ManagementPageContainer/ManagementPageContainer";
import styles from "./styles/NotificationAdmin.module.css";
import { formatDate } from "../../../helpers/formatDate";
import { COLORS } from "../../../constants";
import { initialValues } from "./initialValues";
import { createNotification } from "../../http-request/notification";
import { useNavigate } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";
import CheckChildren from "../../components/CheckChildren/CheckChildren";
import UnCheckChildren from "../../components/UnCheckChildren/UnCheckChildren";

const { Text } = Typography;
const antIcon = (
  <LoadingOutlined style={{ fontSize: 15, color: COLORS.blue1 }} spin />
);

const NotificationAdminCreate = () => {
  const navigate = useNavigate();
  const [dateToday, setdateToday] = useState();
  const [neverExpires, setneverExpires] = useState();
  const [isLoading, setisLoading] = useState(false);

  const [forms] = Form.useForm();

  useEffect(() => {
    let _date = moment();
    _date = formatDate(_date);
    setdateToday(_date);
  }, []);

  return (
    <ManagementPageContainer title={"Add Notification"}>
      <Row justify="end">
        <Text> Date: {dateToday}</Text>
      </Row>
      <div className={styles.info}>
        <Form
          form={forms}
          initialValues={initialValues}
          onFinish={async (value) => {
            setisLoading(true);
            value.expiresAt = value?.expiresAt
              ? formatDate(value.expiresAt)
              : null;

            await createNotification({ ...value, expires: !value.expires })
              .then((result) => {
                if (result) {
                  navigate(-1);
                }
              })
              .finally(() => setisLoading(false));
          }}
        >
          <Row className="fullWidth">
            <Col span={24}>
              <Form.Item name={"title"}>
                <Input placeholder="Title" block />
              </Form.Item>
            </Col>
          </Row>
          <Row className="fullWidth">
            <Col span={24}>
              <Form.Item name={"body"}>
                <Input.TextArea
                  placeholder="Body Text"
                  block
                  style={{ height: "30vh" }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row className="fullWidth">
            <Col
              span={16}
              style={{
                justifyContent: "flex-start",
                alignItems: "center",
                display: "flex",
              }}
            >
              {!neverExpires && (
                <>
                  <Text style={{ styles }}> Exp. Date: </Text>
                  <Form.Item
                    name={"expiresAt"}
                    style={{ margin: "0 0 0 20px" }}
                  >
                    <DatePicker
                      disabledDate={(current) => {
                        return moment().add(1, "days") > current;
                      }}
                    />
                  </Form.Item>
                </>
              )}
            </Col>
            <Col
              span={8}
              style={{ justifyContent: "flex-end", display: "flex" }}
            >
              <Form.Item
                valuePropName={"checked"}
                name={"expires"}
                style={{ margin: 0 }}
              >
                <Switch
                  checked={neverExpires}
                  onChange={(value) => setneverExpires(value)}
                  checkedChildren={<CheckChildren>Never Expires</CheckChildren>}
                  unCheckedChildren={<UnCheckChildren>Expires</UnCheckChildren>}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row justify="start" style={{ margin: "20px 0 20px 0" }}>
            <Col
              span={12}
              style={{ justifyContent: "flex-start", display: "flex" }}
            >
              <Button
                htmlType="reset"
                style={{ border: 0, backgroundColor: COLORS.orange }}
              >
                DISCARD
              </Button>
            </Col>
            <Col
              span={12}
              style={{ justifyContent: "flex-end", display: "flex" }}
            >
              <Button disabled={isLoading} htmlType="submit" type="primary">
                {isLoading ? <Spin indicator={antIcon} /> : "PUBLISH"}
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    </ManagementPageContainer>
  );
};

export default NotificationAdminCreate;
